import {createSelector, Selector} from '@reduxjs/toolkit';

import {TAppState} from 'store/config/types';
import {ETL_SLICE} from 'store/slices/etl-slice/model/constants';
import {IEtlAuditTableData, IEtlSliceState} from 'store/slices/etl-slice/model/types';

const rootSelector: Selector<TAppState, IEtlSliceState> = (state: TAppState) => state[ETL_SLICE];

export const selectEtlAuditData: Selector<TAppState, IEtlAuditTableData | undefined> = createSelector(
    rootSelector,
    state => state?.etlAuditData,
);

export const selectEtlAuditDataLoading: Selector<TAppState, boolean> = createSelector(
    rootSelector,
    state => state.isLoading,
);
